/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";

export interface BaseProgressionMetadata {
  /** Optional partner intent to be provided from FE local storage. */
  partner_intent?: PartnerIntentRequest | null;
  /** Deprecated: send clinic_request_id on the request root instead. */
  clinic_request_id?: string | null;
}
